import dashboard from './dashboard';
import posts from './posts';
import configs from './configs';
import specialConfigs from './special-configs';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, posts, configs, specialConfigs]
};

export default menuItems;
